import { completedManga } from "@/mocks/manga";
import MangaCard from "./MangaCard";
import SectionHeader from "./SectionHeader";

export default function Completed() {
  const featured = completedManga[0];
  const rest = completedManga.slice(1);

  return (
    <section id="completed" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          tag="一口气看完"
          title="完结漫画精选"
          desc="完结作品全部标注完整话数与完结进度，想找一部能一口气读完的好漫画，从这里开始最省心。"
        />

        {featured && (
          <a
            href="#about"
            className="group mb-8 flex flex-col overflow-hidden rounded-lg bg-foreground-950 text-background-50 ring-1 ring-background-200 transition duration-300 hover:-translate-y-1 md:flex-row"
            title={`${featured.title} 完结漫画 ${featured.latestChapter}`}
          >
            <div className="relative h-56 w-full shrink-0 md:h-auto md:w-2/5">
              <img
                src={featured.cover}
                alt={`${featured.title} 完结漫画主视觉`}
                className="h-full w-full object-cover object-top"
                loading="lazy"
              />
              <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
                完结精选
              </span>
            </div>
            <div className="flex flex-1 flex-col justify-center p-6 md:p-10">
              <p className="text-xs text-accent-400">本周推荐完结 · {featured.category}</p>
              <h3 className="mt-2 font-heading text-2xl tracking-wide text-background-50">
                {featured.title}
              </h3>
              <p className="mt-3 max-w-xl text-sm leading-relaxed text-background-200">
                {featured.desc}
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {featured.tags.map((t) => (
                  <span key={t} className="rounded-full bg-background-100/15 px-3 py-1 text-xs text-background-100">
                    {t}
                  </span>
                ))}
              </div>
              <div className="mt-6 inline-flex items-center gap-2 whitespace-nowrap self-start rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition group-hover:bg-accent-600">
                {featured.latestChapter} · 立即阅读
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          </a>
        )}

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5 md:gap-5">
          {rest.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>

        <div className="mt-8 rounded-lg bg-primary-100/70 px-6 py-5 text-center">
          <p className="text-sm text-primary-900">
            想看更多完结漫画？收藏后进度与完整话数都会自动保存，随时回来续看。
          </p>
        </div>
      </div>
    </section>
  );
}